import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {renderIf, renderMail, renderPhone} from '../../../../Shared'
import {HeaderWithIconLine} from '../../../Templates/items/ListHeader'
import getLabelOfGender from "../../../../../helpers/getLabelOfGender";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {EstimatedDobTag} from 'components/common/EstimatedDobTag'
import {ItemInformation} from 'components/common/ItemInformation'
import {BsInfoCircleFill} from "react-icons/bs";
import {convertStringToDate} from "../../../../../helpers/dateUtils";
import {DatePlaceItem} from "../../../../../components/common/DatePlaceItem";

export const StudentInformationCompact = ({student}) => {
    const t = useTranslate()
    const {
        student_idcode,
        prefix_title,
        patron_saint_name,
        fullname,
        gender,
        date_of_birth,
        date_of_birth_is_estimated,
        place_of_birth,
        contact_phone,
        contact_email,
    } = student ?? {}

    // BE lưu NULL thật khi học viên chưa có ngày sinh (không bịa giá trị giả) - chỉ cần check rỗng.
    const isUnknownDob = !date_of_birth

    return (
        <div className="mb-3 px-4 py-3 flex flex-col border border-color-50 background shadow-md rounded-2xl">
            <span className="font-semibold text-sm text-slate-700 tracking-wider">
                {t('student information')}
            </span>
            <div style={{height: 3}} className="mt-1 mb-2 w-20 rounded-full bg-gray-400"/>
            <div className="flex flex-col gap-1 ml-2">
                <ItemInformation
                    showIcon={true}
                    primary={true}
                    label="fullname"
                    value={`${prefix_title || patron_saint_name || ''} ${fullname}`}
                    className="text-xs tracking-wider"
                />
                <ItemInformation
                    showIcon={true}
                    label="student code"
                    value={student_idcode}
                    className="text-xs tracking-wider"
                />
                <ItemInformation
                    showIcon={true} className="text-xs tracking-wider"
                    label="gender" value={t(getLabelOfGender(gender))}
                />
                <DatePlaceItem
                    showIcon={true}
                    label="date of birth"
                    date={
                        isUnknownDob
                            ? t('not update')
                            : (
                                <span className="space-x-2">
                                    {convertStringToDate(date_of_birth).format('DD/MM/YYYY')}
                                    {date_of_birth_is_estimated && <EstimatedDobTag/>}
                                </span>
                            )
                    }
                    place={place_of_birth}
                    className="text-xs tracking-wider"
                />
                {renderIf(
                    _.some([contact_phone, contact_email]),
                    <DoubleValueItem
                        showIcon={true}
                        labelFirst="contact"
                        valueFirst={renderPhone(contact_phone)}
                        labelSecond={contact_email ? ' - ' : ''}
                        valueSecond={renderMail(contact_email)}
                        className="text-xs tracking-wider"
                    />
                )}
            </div>
        </div>
    )
}
